import './WorkflowContent.css';
import workflow from '../../../assets/workflow-min.png';
export default function WorkflowContent() {
  return (
    <div className="middle-content-container">
      <div className="middle-content-inner">
        <div className="svgContainer">
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end', // Right-align everything in this block
              marginBottom: '8px',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <span
                style={{
                  fontWeight: 'bold',
                  fontSize: '15px',
                  color: '#0b57d0',
                }}
              >
                Lab - Workflow Guide
              </span>
              <span
                style={{
                  fontSize: '13px',
                  color: '#444',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Zm0 1.8a8.2 8.2 0 1 0 0 16.4A8.2 8.2 0 0 0 12 3.8Zm.9 5.2v1.8h-1.8V9H13Zm0 3.6v6.4h-1.8v-6.4H13Z"
                  />
                </svg>
                Request process will take place outside the DLI portal.
              </span>
            </div>

            {/* Google Form Link */}
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSeuJHcdEZlig9VlXwrZ4oA-CUb1kNbplOwl_iiXOnzJIE1KaA/viewform"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                fontSize: '13px',
                color: '#0b57d0',
                textDecoration: 'underline',
                marginTop: '4px',
              }}
            >
              Google Form
            </a>
          </div>
          <img style={{ width: '100%', paddingBottom: '100px' }} src={workflow} />
        </div>
      </div>
    </div>
  );
}
